import PeopleOutline from "@mui/icons-material/PeopleOutline"
import NotificationsOutlined from "@mui/icons-material/NotificationsOutlined"
import ImageOutlined from "@mui/icons-material/ImageOutlined"
import Link from "@mui/icons-material/Link"
import Gavel from "@mui/icons-material/Gavel"
import AssignmentOutlined from "@mui/icons-material/AssignmentOutlined"
import AdminPanelSettingsOutlined from "@mui/icons-material/AdminPanelSettingsOutlined"
import SchoolOutlined from "@mui/icons-material/SchoolOutlined"
import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined"

const INACTIVE = "#ADB5BD"
const ACTIVE = "#1576BC"
const SIZE = 38

// Same convention as the other roles' nav icons: one line-art shape, grey
// when inactive and blue when active. The stroke is thickened so MUI's thin
// outlined glyphs match the 2.4px strokes of the custom SVG icons.
const navIcon = (Icon) => ({
  icon: <Icon sx={{ fontSize: SIZE, color: INACTIVE, stroke: INACTIVE, strokeWidth: 0.6 }} />,
  iconActive: <Icon sx={{ fontSize: SIZE, color: ACTIVE, stroke: ACTIVE, strokeWidth: 0.6 }} />,
})

export const adminNavIcons = {
  userManagement: navIcon(PeopleOutline),
  adminManagement: navIcon(AdminPanelSettingsOutlined),
  teacherManagement: navIcon(SchoolOutlined),
  notificationManagement: navIcon(NotificationsOutlined),
  templateNotification: navIcon(DescriptionOutlined),
  bannerManagement: navIcon(ImageOutlined),
  linksManager: navIcon(Link),
  procurementProcess: navIcon(Gavel),
  lxoTask: navIcon(AssignmentOutlined),
}
